import { Box, Paper, Stack, Switch, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { customersUrl } from "../../utils/urls";
import { toast } from "react-hot-toast";
import { hideLoader, showLoader } from "../../store/loaderSlice";
import { useDispatch } from "react-redux";
import axiosInstance from "../../utils/axiosInstance";

const CustomerStatus = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(showLoader("Fetching Customer..."));
    axiosInstance.get(`${customersUrl}/${params.id}`)
      .then(res => {
        setStatus(res.data.status);
        dispatch(hideLoader());
      })
      .catch(err => {
        console.log(err);
        dispatch(hideLoader());
      });
  }, [params.id, dispatch]);

  const handleStatusChange = (event) => {
    setIsLoading(true);
    const newStatus = event.target.checked;
    setStatus(newStatus);

    axiosInstance.post(`${customersUrl}/${params.id}/status`, { status: newStatus })
      .then(() => {
        toast.success(`Customer status changed to ${newStatus ? "Active" : "Inactive"}.`);
      })
      .catch(err => {
        console.error("Error updating status:", err);
        toast.error("Failed to update status.");
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <Stack spacing={5} height={"100%"}>
      <Typography variant="h5">Customer Status</Typography>
      <Paper elevation={2} sx={{ flex: 1, display: "flex" }}>
        <Stack px={2} py={3} flex={1}>
          <Box display="flex" alignItems="center" mt={2}>
            <Typography>Status:</Typography>
            <Switch
              disabled={isLoading}
              checked={status}
              onChange={handleStatusChange}
              sx={{ ml: 2 }}
            />
          </Box>
        </Stack>
      </Paper>
    </Stack>
  );
};

export default CustomerStatus;
